import { useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategoryDropdown from './components/CategoryDropdown';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturesSection from './components/FeaturesSection';
import SEOContentSection from './components/SEOContentSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  const categoryGridRef = useRef<HTMLDivElement>(null);

  const scrollToCategories = () => {
    categoryGridRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Kakobuy Finds",
            "url": import.meta.env.VITE_SITE_URL,
            "description": "Największa baza produktów Kakobuy Spreadsheet - odkrywaj najlepsze okazje zakupowe.",
            "inLanguage": "pl",
            "potentialAction": {
              "@type": "SearchAction",
              "target": import.meta.env.VITE_SITE_URL + "/?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }),
        }}
      />
      <Navbar onCTAClick={scrollToCategories} />
      <main>
        <Hero />
        <TrustBar />
        <CategoryDropdown />
        <AboutSection />
        <div ref={categoryGridRef}>
          <CategoryGrid />
        </div>
        <FeaturesSection />
        <SEOContentSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}